export default [{
	titulo: 'Páginas',
	icone: 'menu-icon fa fa-caret-right',
	url: '/sistema/paginas',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]